var staticStrFirst = 'first'

module.exports = staticStrFirst



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticStrFirst.js
// module id = 174
// module chunks = 75